import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import FounderActions from './FounderActions';
import { radarReports } from '../data/opportunityRadar';

const mountedRoots = new Map();

const currentReportFromPage = () => {
  const dateHeading = Array.from(document.querySelectorAll('main h2')).find((node) =>
    radarReports.some((report) => node.textContent?.trim() === report.reportDate)
  );
  return radarReports.find((report) => report.reportDate === dateHeading?.textContent?.trim()) || radarReports[0];
};

const mountActions = () => {
  if (window.location.pathname.replace(/\/+$/, '') !== '/radar') return;
  const report = currentReportFromPage();
  if (!report) return;

  document.querySelectorAll('article').forEach((article) => {
    const title = article.querySelector('h3')?.textContent?.trim();
    const item = report.opportunities.find((opportunity) => opportunity.name === title);
    if (!item || article.querySelector('[data-founder-actions]')) return;

    const mount = document.createElement('div');
    mount.dataset.founderActions = 'true';
    const mainColumn = article.querySelector('.xl\\:grid-cols-\\[minmax\\(0\\,1fr\\)_340px\\] > div:first-child');
    (mainColumn || article).appendChild(mount);

    const root = createRoot(mount);
    root.render(<FounderActions report={report} item={item} />);
    mountedRoots.set(mount, root);
  });
};

export default function RadarActionsBridge() {
  useEffect(() => {
    if (window.location.pathname.replace(/\/+$/, '') !== '/radar') return undefined;

    let frame;
    const scheduleMount = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(mountActions);
    };

    scheduleMount();
    const observer = new MutationObserver(scheduleMount);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      mountedRoots.forEach((root, node) => {
        root.unmount();
        node.remove();
      });
      mountedRoots.clear();
    };
  }, []);

  return null;
}
